var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 px-5"},[_c('embed',{staticStyle:{"height":"100vh"},attrs:{"src":"https://ai.mitrawarung.id/in/chat?token=Yxcm50Gf3FrtKN6VAdhP9WGiD&name=admin&segment=admin","width":"100%"}})])
}]

export { render, staticRenderFns }